import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Service$SolvuuApi0 from "./service.bs.js";
import * as Term_event_bs$SolvuuApi0 from "./term_event_bs.bs.js";
import * as Term_event_atd$SolvuuApi0 from "./term_event_atd.bs.js";
import * as Term_events_bs$SolvuuApi0 from "./term_events_bs.bs.js";
import * as Term_events_atd$SolvuuApi0 from "./term_events_atd.bs.js";
import * as Term_get_request_atd$SolvuuApi0 from "./term_get_request_atd.bs.js";
import * as Term_get_response_atd$SolvuuApi0 from "./term_get_response_atd.bs.js";
import * as Term_mkdir_request_atd$SolvuuApi0 from "./term_mkdir_request_atd.bs.js";
import * as Term_create_request_atd$SolvuuApi0 from "./term_create_request_atd.bs.js";
import * as Term_mkdir_response_atd$SolvuuApi0 from "./term_mkdir_response_atd.bs.js";
import * as Term_create_response_atd$SolvuuApi0 from "./term_create_response_atd.bs.js";
import * as Term_get_by_id_request_atd$SolvuuApi0 from "./term_get_by_id_request_atd.bs.js";
import * as Term_get_by_id_response_atd$SolvuuApi0 from "./term_get_by_id_response_atd.bs.js";
import * as Term_get_events_request_atd$SolvuuApi0 from "./term_get_events_request_atd.bs.js";
import * as Term_get_events_response_atd$SolvuuApi0 from "./term_get_events_response_atd.bs.js";
var entity = "terms";
var service = Service$SolvuuApi0.Get_by_id.service(entity);

var path = Curry._1(Service$SolvuuApi0.Get_by_id.$$Request.path, entity);

var body = Service$SolvuuApi0.Get_by_id.$$Request.body;

var info = Curry._1(Service$SolvuuApi0.Get_by_id.$$Request.info, entity);

var service$1 = "Term.Get";

function path$1(param) {
  return (
    /* :: */
    ["term",
    /* :: */
    ["eval",
    /* [] */
    0]]
  );
}

function body$1(ri) {
  return (
    /* `Json */
    [826371656, Curry._1(Term_get_request_atd$SolvuuApi0.json_of_info, ri)]
  );
}

function info$1(path, body) {
  if (path && path[0] === "term") {
    var match = path[1];

    if (match && match[0] === "eval" && !match[1]) {
      if (typeof body === "number") {
        return Pervasives.failwith(Curry._1(Printf.sprintf(
        /* Format */
        [
        /* String */
        Block.__(2, [
        /* No_padding */
        0,
        /* String_literal */
        Block.__(11, [".request_info: invalid empty body",
        /* End_of_format */
        0])]), "%s.request_info: invalid empty body"]), service$1));
      } else {
        return Curry._1(Term_get_request_atd$SolvuuApi0.info_of_json, body[1]);
      }
    } else {
      return Service$SolvuuApi0.failwith_unexpected_path(service$1, path);
    }
  } else {
    return Service$SolvuuApi0.failwith_unexpected_path(service$1, path);
  }
}

var service$2 = Service$SolvuuApi0.Create.service(entity);

function path$2(param) {
  return Curry._1(Service$SolvuuApi0.Create.$$Request.path, entity);
}

var body$2 = Curry._1(Service$SolvuuApi0.Create.$$Request.body, Term_create_request_atd$SolvuuApi0.json_of_info);

var info$2 = Curry._1(Service$SolvuuApi0.Create.$$Request.info, Term_create_request_atd$SolvuuApi0.info_of_json);

function path$3(param) {
  return (
    /* :: */
    ["term",
    /* :: */
    ["mkdir",
    /* [] */
    0]]
  );
}

function body$3(ri) {
  return (
    /* `Json */
    [826371656, Curry._1(Term_mkdir_request_atd$SolvuuApi0.json_of_info, ri)]
  );
}

function info$3(path, body) {
  if (path && path[0] === "term") {
    var match = path[1];

    if (match && match[0] === "mkdir" && !match[1]) {
      if (typeof body === "number") {
        return Pervasives.failwith("Term.Mkdir.request_info: invalid empty body");
      } else {
        return Curry._1(Term_mkdir_request_atd$SolvuuApi0.info_of_json, body[1]);
      }
    }
  }

  return Pervasives.failwith(Curry._1(Printf.sprintf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["Term.Mkdir.request_info: expected path 'term/mkdir' but got ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* End_of_format */
  0])]), "Term.Mkdir.request_info: expected path 'term/mkdir' but got %s"]), $$String.concat("/", path)));
}

var service$3 = Service$SolvuuApi0.Get_events.service(entity);

var path$4 = Curry._1(Service$SolvuuApi0.Get_events.$$Request.path, entity);

function body$4(param) {
  return Service$SolvuuApi0.Get_events.$$Request.body;
}

var info$4 = Curry._1(Service$SolvuuApi0.Get_events.$$Request.info, entity);

var $$Event = {
  Json: Term_event_bs$SolvuuApi0,
  json_of_event: Term_event_atd$SolvuuApi0.json_of_event,
  json_of_blob_id: Term_event_atd$SolvuuApi0.json_of_blob_id,
  json_of_job_id: Term_event_atd$SolvuuApi0.json_of_job_id,
  json_of_type_: Term_event_atd$SolvuuApi0.json_of_type_,
  json_of_payload: Term_event_atd$SolvuuApi0.json_of_payload,
  json_of_info: Term_event_atd$SolvuuApi0.json_of_info,
  json_of_t: Term_event_atd$SolvuuApi0.json_of_t,
  event_of_json: Term_event_atd$SolvuuApi0.event_of_json,
  blob_id_of_json: Term_event_atd$SolvuuApi0.blob_id_of_json,
  job_id_of_json: Term_event_atd$SolvuuApi0.job_id_of_json,
  type__of_json: Term_event_atd$SolvuuApi0.type__of_json,
  payload_of_json: Term_event_atd$SolvuuApi0.payload_of_json,
  info_of_json: Term_event_atd$SolvuuApi0.info_of_json,
  t_of_json: Term_event_atd$SolvuuApi0.t_of_json
};
var Events = {
  Json: Term_events_bs$SolvuuApi0,
  json_of_event: Term_events_atd$SolvuuApi0.json_of_event,
  json_of_t: Term_events_atd$SolvuuApi0.json_of_t,
  event_of_json: Term_events_atd$SolvuuApi0.event_of_json,
  t_of_json: Term_events_atd$SolvuuApi0.t_of_json
};
var Get_by_id_Request = {
  path: path,
  body: body,
  info: info
};
var Get_by_id_Response = {
  ok_of_json: Term_get_by_id_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Term_get_by_id_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Term_get_by_id_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Term_get_by_id_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Term_get_by_id_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Term_get_by_id_response_atd$SolvuuApi0.json_of_not_found
};
var Get_by_id = {
  entity: entity,
  service: service,
  $$Request: Get_by_id_Request,
  $$Response: Get_by_id_Response
};
var Get_Request = {
  path: path$1,
  body: body$1,
  info: info$1
};
var Get_Response = {
  ok_of_json: Term_get_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Term_get_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Term_get_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Term_get_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Term_get_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Term_get_response_atd$SolvuuApi0.json_of_not_found
};
var Get = {
  entity: entity,
  service: service$1,
  $$Request: Get_Request,
  $$Response: Get_Response
};
var Create_Request = {
  path: path$2,
  body: body$2,
  info: info$2
};
var Create_Response = {
  ok_of_json: Term_create_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Term_create_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Term_create_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Term_create_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Term_create_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Term_create_response_atd$SolvuuApi0.json_of_not_found
};
var Create = {
  entity: entity,
  service: service$2,
  $$Request: Create_Request,
  $$Response: Create_Response
};
var Mkdir_Request = {
  path: path$3,
  body: body$3,
  info: info$3
};
var Mkdir_Response = {
  ok_of_json: Term_mkdir_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Term_mkdir_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Term_mkdir_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Term_mkdir_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Term_mkdir_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Term_mkdir_response_atd$SolvuuApi0.json_of_not_found
};
var Mkdir = {
  entity: entity,
  service: "Term.Mkdir",
  $$Request: Mkdir_Request,
  $$Response: Mkdir_Response
};
var Get_events_Request = {
  path: path$4,
  body: body$4,
  info: info$4
};
var Get_events_Response = {
  ok_of_json: Term_get_events_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Term_get_events_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Term_get_events_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Term_get_events_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Term_get_events_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Term_get_events_response_atd$SolvuuApi0.json_of_not_found
};
var Get_events = {
  entity: entity,
  service: service$3,
  $$Request: Get_events_Request,
  $$Response: Get_events_Response
};
export { $$Event, Events, Get_by_id, Get, Create, Mkdir, Get_events };
/* service Not a pure module */